var Curriculog = Curriculog || {};

Curriculog.DomParams = (function ($, _, Backbone, DomParams) {
	
	DomParams = Curriculog.Param.extend({

		defaults: function() {
			return {
				level: 'user',
				filterType: 'tab',
				simpleFilter: '',
				tab: 'all-proposals',
			};
		},

		initialize: function(model, options) {
			this.setAttr(options.defaultDomParams);
			this.user = options.user;
			this.tabParam = options.tabParam;
			this.getDefaultTab();

			this.listenTo(Backbone, 'tabs:change', this.reset);
			this.listenTo(Backbone, 'advancedFilter:toggleOpen', this.reset);
			this.listenTo(Backbone, 'advancedFilter:toggleClosed', this.reset);
		},

		getDefaultTab: function() {
			var defaultTab = this.defaults().tab;
			if (this.get('level') == 'admin') {
				defaultTab = 'needsattention';
			} else if (this.tabParam.length > 0) {
				defaultTab = this.tabParam;
			} else if (this.get('level') == 'user' && this.user.get('id') > 0) {
				defaultTab = 'task';
			}
			this.set('tab', defaultTab);
		},

		setAttr: function(attributes) {
			attributes = _.pick(attributes, _.keys(this.defaults()));
			this.set(attributes);
			return this.attributes;
		},

		reset: function() {
			this.set('simpleFilter', '');
		}

	});

	return DomParams;

})($, _, Backbone, Curriculog.DomParams || {});